import { render, staticRenderFns } from "./select-project.vue?vue&type=template&id=4a0fdd27&scoped=true"
import script from "./select-project.vue?vue&type=script&lang=js"
export * from "./select-project.vue?vue&type=script&lang=js"
import style0 from "./select-project.vue?vue&type=style&index=0&id=4a0fdd27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fdd27",
  null
  
)

export default component.exports